import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const WIDGET_KEY = process.env.REACT_APP_CHAT_WIDGET_KEY;
const WIDGET_SRC = process.env.REACT_APP_CHAT_WIDGET_URL;

/**
 * Loads the TeamUp chat widget script once and initialises it with the
 * signed-in user's access token. Renders nothing.
 */
const ChatWidget = () => {
  const { token } = useAuth();
  const { pathname } = useLocation();
  const onDashboard = pathname.startsWith('/dashboard');

  useEffect(() => {
    if (!WIDGET_KEY || !token || !onDashboard) return;

    const w = window;
    const d = document;

    w.ChatWidget =
      w.ChatWidget ||
      function () {
        (w.ChatWidget.q = w.ChatWidget.q || []).push(arguments);
      };

    if (!d.getElementById('teamup-chat-widget')) {
      const s = d.createElement('script');
      s.id = 'teamup-chat-widget';
      s.src = WIDGET_SRC;
      s.async = true;
      d.head.appendChild(s);
    }

    w.ChatWidget('init', {
      key: WIDGET_KEY,
      token,
      getToken: function () {
        return localStorage.getItem('token');
      },
    });
  }, [token, onDashboard]);

  return null;
};

export default ChatWidget;
